module.exports = __webpack_public_path__ + "img/9788980403431.662d8867.jpg";